import React, { useContext, useEffect, useState } from 'react';
import { ask__ } from './../../shared/utils/i18n.js';
import { findClient } from './../../shared/utils/api.js';
import { GlobalErrorContext } from './../../shared/context/GlobalErrorContext.js';
import { GlobalUserContext } from '../../shared/context/GlobalUserContext.js';
import { GlobalIsRegisteredContext } from '../../shared/context/GlobalIsRegistered.js';

import Icon from '../Icon/Icon';
import Loader from '../Loader/Loader';
import Login from '../Login/Login';
import EditProfile from '../EditProfile/EditProfile';
import Reservations from '../Reservations/Reservations';
import Footer from '../Footer/Footer';

import './Profile.scss';

export default function Profile() {

  const {setGlobalError} = useContext(GlobalErrorContext);
  const {getGlobalIsRegistered} = useContext(GlobalIsRegisteredContext);
  const {getGlobalUser} = useContext(GlobalUserContext);

  const [isMetaLoading, setIsMetaLoading] = useState(true);
  const [metaCacheBuster, setMetaCacheBuster] = useState(Date.now());
  const [clientData, setClientData] = useState(false);

  const [isEditingProfile, setIsEditingProfile] = useState(false);

  // user meta
  useEffect(() => {

    (async () => {

      setIsMetaLoading(true);

      if (getGlobalUser.isLoggedIn && getGlobalIsRegistered) {

        try {
          const client = await findClient();
          setClientData(client);
        } catch(err) {
          console.error(err);
          setGlobalError({
            isError: true,
            errorCode: 'PCL201'
          });
        }

      }

      setIsMetaLoading(false);

    })();

  }, [metaCacheBuster, getGlobalIsRegistered]); // runs only on mount



  return (
    <>
      {getGlobalUser.isLoggedIn && getGlobalIsRegistered ? <>

        <div className="profile">

          <h2>{ask__('Profile: My reservations')}</h2>

          <div className="profile__reservations">
            <Reservations type="all" />
          </div>


          <h2>{ask__('Profile: Contact information')}</h2>

          {isMetaLoading ? <>

            <Loader align="left" />

          </> : <>

            {clientData ? <>
              <div className="profile__meta">

                <div className="profile__meta__col profile__meta__col-1">
                  <span>{`${clientData.firstName} ${clientData.lastName}`}</span>
                </div>
                <div className="profile__meta__col profile__meta__col-2">
                  <span>{`${clientData.address}`}</span>
                  <span>{`${clientData.postcode} ${clientData.city}`}</span>
                </div>
                <div className="profile__meta__col profile__meta__col-3">
                  <span>{`${clientData.email}`}</span>
                  <span>{`${clientData.phone}`}</span>
                </div>

              </div>
            </> : ''}

            <div className="profile__edit">
              <button
                onClick={e => {
                  e.preventDefault();
                  setIsEditingProfile(true);
                }}
              >
                <Icon name="edit-outline" />
                {ask__('Profile: Edit')}
              </button>
            </div>

            {isEditingProfile ? <>
              <EditProfile
                onClose={() => {
                  setIsEditingProfile(false);
                  setMetaCacheBuster(Date.now());
                }}
              />
            </> : ''}

          </>}
          <Footer />
        </div>

      </> : <>

        <Login type="generic" />

      </>}
    </>
  );

}
